import { Injectable, inject } from '@angular/core';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class ClientsGuard {
  private readonly user_service = inject(UserService);

  canActivate(): boolean {
    return this.user_service.getCurrentUser()?.role?.slug === 'client';
  }
}
